import Table from "components/Table/Table";
import { commonColumnProps, OFFSET, PAGE_SIZE } from "constants/TableConstants";
import { useEffect, useState } from "react";
import type { CellClickArgs } from "react-data-grid";
import { useLocation, useNavigate } from "react-router-dom";
import { setIsLoading } from "reducers/main";
import { useGetInsurersQuery } from "services/insurer-api";
import type { InsurerType } from "types/DataTypes";
import { useQuery } from "utils/hooks";
import { useDispatch } from "utils/redux";
import { GLOBAL_SEARCH_PARAM } from "utils/useUrlStore";

import InsurerTPAPageContainer from "./InsurerTPAPageContainer";

const INSURER_COLUMNS = [
  { key: "name", name: "Name", ...commonColumnProps },
  { key: "address", name: "Address", ...commonColumnProps },
  { key: "state", name: "State", ...commonColumnProps },
  {
    key: "zipcode",
    name: "Zipcode",
    render: (value: string | null) => value || "-",
  },
];

const InsurerTable = () => {
  const dispatch = useDispatch();
  const location = useLocation();
  const navigate = useNavigate();
  const query = useQuery();
  const [page, setPage] = useState(1);

  const { data: insurers = { results: [], count: 0 }, isLoading } =
    useGetInsurersQuery(
      {
        searchTerm: query.get(GLOBAL_SEARCH_PARAM) || undefined,
        limit: PAGE_SIZE,
        offset: OFFSET(page),
      },
      { skip: false },
    );

  const handleCellClick = (args: CellClickArgs<InsurerType, unknown>) => {
    navigate(`${location.pathname}/${args.row.id}/overview`);
  };

  useEffect(() => {
    dispatch(setIsLoading(isLoading));
  }, [dispatch, isLoading]);

  return (
    <InsurerTPAPageContainer>
      <Table
        className="insurers-table"
        columns={INSURER_COLUMNS}
        rows={insurers.results}
        rowKeyGetter={(row: InsurerType) => row.id}
        onCellClick={handleCellClick}
        isLoading={isLoading}
        fullHeight
        pagination={{
          pageSize: PAGE_SIZE,
          pageIndex: page,
          rowCount: insurers.count,
          onPageChange: setPage,
          isLoading,
        }}
      />
    </InsurerTPAPageContainer>
  );
};

export default InsurerTable;
